import request from '@/utils/request'
/**
 *
 * 人员管理
 *
 **/
// 登录、
export const login = (data: any) =>
  request({
    'url': '/employee/login',
    'method': 'post',
    data
  })
  // 退出
 export const userLogout = (params: any) =>
 request({
   'url': `/employee/logout`, // 授课老师接口
   'method': 'post',
   params
 })

export const getEmployeeList = (params: any) => {
  return request({
    url: '/employee/page',
    method: 'get',
    params
  })
}

// 修改---启用禁用接口
export const enableOrDisableEmployee = (params: any) => {
  return request({
    url: `/employee/status/${params.status}`,
    method: 'post',
    params: { id:params.id }
  })
}

// 新增---添加员工
export const addEmployee = (params: any) => {
  return request({
    url: '/employee',
    method: 'post',
    data: { ...params }
  })
}

// 修改---添加员工
export const editEmployee = (params: any) => {
  return request({
    url: '/employee',
    method: 'put',
    data: { ...params }
  })
}

// 修改页面反查详情接口
export const queryEmployeeById = (id: string | (string | null)[]) => {
  return request({
    url: `/employee/${id}`,
    method: 'get'
  })
}

/** 删除人员（管理员账号不可删） */
export const deleteEmployee = (id: number | string) => {
  return request({
    url: `/employee/${id}`,
    method: 'delete'
  })
}

/** 当前登录员工资料 */
export const getEmployeeProfile = () => {
  return request({
    url: '/employee/profile',
    method: 'get'
  })
}

/** 修改本人姓名、手机号、邮箱 */
export const updateEmployeeProfile = (data: { name: string, phone: string, email?: string }) => {
  return request({
    url: '/employee/profile',
    method: 'put',
    data
  })
}
